import AsyncStorage from '@react-native-async-storage/async-storage';

async function setStorageItem(key: string, value: string | number | boolean) {
	const stringValue = value.toString();
	await AsyncStorage.setItem(key, stringValue);
}

async function setArray(key: string, value: unknown[]) {
	const stringValue = JSON.stringify(value);
	await AsyncStorage.setItem(key, stringValue);
}

async function getString(key: string) {
	return await AsyncStorage.getItem(key);
}

async function getBoolean(key: string) {
	const value = await getString(key);
	if (value !== null) {
		return value === 'true';
	}

	return value;
}

async function getArray(key: string) {
	const value = await AsyncStorage.getItem(key);
	if (!value) {
		return [];
	}

	const parsedValue = JSON.parse(value);
	if (!Array.isArray(parsedValue)) {
		return [];
	}

	return parsedValue;
}

const removeItem = AsyncStorage.removeItem;

export { setStorageItem, setArray, getString, getBoolean, getArray, removeItem };
